<ng-template #formFields>
  <div [formGroup]="form">
  <div class="row">
    <div class="col-12 col-md-4 mb-4">
      @if (isNationalId) {
        <div class="value-wrapper">
          <p class="form-label">{{ 'pages.organization.registrationCountry' | translate }}</p>
          <p class="form-value">{{ legalEntity?.country?.name || '-' }}</p>
        </div>
      } @else {
        <div class="label-wrapper">
          <label class="form-label lna" for="countryId">
            {{ 'pages.organization.registrationCountry' | translate }}
            <span class="required-field">*</span>
          </label>
        </div>
        <select
          id="countryId"
          [ngClass]="{
            invalid: this.shouldRenderError('countryId') && countryId?.invalid && (countryId?.touched || submitAttempted)
          }"
          (blur)="onCountryBlur()"
          formControlName="countryId">
          <option class="empty-option" [value]="-1" [selected]="true" disabled>
            {{ 'pages.organization.chooseCountry' | translate }}
          </option>
          @for (country of countries; track country.id) {
            <option [value]="country.id">{{ country.name }}</option>
          }
        </select>
        <div class="error-wrapper">
          @if (this.shouldRenderError('countryId') && countryId?.invalid) {
            @if (countryId?.errors?.['min']) {
              <small class="error-message">
                {{ 'components.form.errorRequired' | translate }}
              </small>
            }
          }
        </div>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-4 mb-4">
      @if (isNationalId) {
        <div class="value-wrapper">
          <p class="form-label">{{ 'pages.organization.registrationNumber' | translate }}</p>
          <p class="form-value">{{ legalEntity?.registrationNumber || '-' }}</p>
        </div>
      } @else {
        <div class="label-wrapper">
          <label class="form-label lna" for="registrationNumber">
            {{ 'pages.organization.registrationNumber' | translate }}
            <span class="required-field">*</span>
          </label>
        </div>
        <input
          class="form-control lna"
          id="registrationNumber"
          [ngClass]="{
            invalid: this.shouldRenderError('registrationNumber') && registrationNumber?.errors
          }"
          [maxlength]="registrationNumberMaxLength"
          type="text"
          formControlName="registrationNumber"
          name="registrationNumber" />
        <div class="error-wrapper">
          @if (this.shouldRenderError('registrationNumber') && registrationNumber?.errors) {
            @if (registrationNumber?.errors?.['required']) {
              <small class="error-message">
                {{ 'components.form.errorRequired' | translate }}
              </small>
            } @else if (registrationNumber?.errors?.['invalidRegistrationNumber']) {
              <small class="error-message">
                {{ 'components.form.invalidRegistrationNumber' | translate }}
              </small>
            } @else if (registrationNumber?.errors?.['maxlength']) {
              <small class="error-message">
                {{
                  'components.form.maxLength'
                    | translate
                      : {
                          maxLength: registrationNumber?.errors?.['maxlength']['requiredLength']
                        }
                }}
              </small>
            }
          }
        </div>
      }
    </div>
    <div class="col-12 col-md-4 mb-4">
      @if (isNationalId) {
        <div class="value-wrapper">
          <p class="form-label">{{ 'pages.organization.name' | translate }}</p>
          <p class="form-value">{{ legalEntity?.name || '-' }}</p>
        </div>
      } @else {
        <div class="label-wrapper">
          <label class="form-label lna" for="name">
            {{ 'pages.organization.name' | translate }}
            <span class="required-field">*</span>
          </label>
        </div>
        <input
          class="form-control lna"
          id="name"
          [ngClass]="{
            invalid: this.shouldRenderError('name') && name?.errors
          }"
          type="text"
          formControlName="name"
          name="name" />
        <div class="error-wrapper">
          @if (this.shouldRenderError('name') && name?.errors) {
            @if (name?.errors?.['required']) {
              <small class="error-message">
                {{ 'components.form.errorRequired' | translate }}
              </small>
            } @else if (name?.errors?.['maxlength']) {
              <small class="error-message">
                {{
                  'components.form.maxLength'
                    | translate
                      : {
                          maxLength: name?.errors?.['maxlength']['requiredLength']
                        }
                }}
              </small>
            }
          }
        </div>
      }
    </div>
    <div class="col-12 col-md-4 mb-4">
      <div class="label-wrapper">
        <label class="form-label lna" for="type">
          {{ 'pages.organization.legalEntityForm' | translate }}
          <span class="required-field">*</span>
        </label>
      </div>
      <select
        id="type"
        [ngClass]="{
          invalid: this.shouldRenderError('type') && type?.invalid && (type?.touched || submitAttempted)
        }"
        formControlName="type">
        <option value="">{{ 'pages.organization.chooseLegalEntityForm' | translate }}</option>
        @for (option of legalEntityFormOptions; track option.code) {
          <option [value]="option.code">{{ option.name }}</option>
        }
      </select>
      <div class="error-wrapper">
        @if (this.shouldRenderError('type') && type?.invalid) {
          @if (type?.errors?.['required']) {
            <small class="error-message">
              {{ 'components.form.errorRequired' | translate }}
            </small>
          }
        }
      </div>
    </div>
  </div>
  <div class="contact-section">
    <div class="contact-info-heading">
      <h4>{{ 'pages.organization.contactInfoTitle' | translate }}</h4>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 mb-4">
        <div class="label-wrapper">
          <label class="form-label lna" for="email">
            {{ 'pages.organization.email' | translate }}
          </label>
        </div>
        <input
          class="form-control lna"
          id="email"
          [ngClass]="{
            invalid: this.shouldRenderError('email') && email?.errors
          }"
          type="text"
          formControlName="email"
          name="email" />
        <div class="error-wrapper">
          @if (this.shouldRenderError('email') && email?.errors) {
            @if (email?.errors?.['invalidEmail']) {
              <small class="error-message">
                {{ 'components.form.invalidEmail' | translate }}
              </small>
            } @else if (email?.errors?.['minlength']) {
              <small class="error-message">
                {{
                  'components.form.minLength'
                    | translate
                      : {
                          minLength: email?.errors?.['minlength']['requiredLength']
                        }
                }}
              </small>
            } @else if (email?.errors?.['maxlength']) {
              <small class="error-message">
                {{
                  'components.form.maxLength'
                    | translate
                      : {
                          maxLength: email?.errors?.['maxlength']['requiredLength']
                        }
                }}
              </small>
            }
          }
        </div>
      </div>
      <div class="col-12 col-md-4 mb-4">
        <div class="label-wrapper">
          <label class="form-label lna" for="phone">
            {{ 'pages.organization.phone' | translate }}
          </label>
        </div>
        <input
          class="form-control lna"
          id="phone"
          [ngClass]="{
            invalid: this.shouldRenderError('phone') && phone?.errors
          }"
          type="text"
          formControlName="phone"
          name="phone" />
        <div class="error-wrapper">
          @if (this.shouldRenderError('phone') && phone?.errors) {
            @if (phone?.errors?.['invalidPhone']) {
              <small class="error-message">
                {{ 'components.form.invalidPhone' | translate }}
              </small>
            } @else if (phone?.errors?.['minlength']) {
              <small class="error-message">
                {{
                  'components.form.minLength'
                    | translate
                      : {
                          minLength: phone?.errors?.['minlength']['requiredLength']
                        }
                }}
              </small>
            } @else if (phone?.errors?.['maxlength']) {
              <small class="error-message">
                {{
                  'components.form.maxLength'
                    | translate
                      : {
                          maxLength: phone?.errors?.['maxlength']['requiredLength']
                        }
                }}
              </small>
            }
          }
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8">
        <div class="label-wrapper">
          <label class="form-label lna" for="legalAddress">
            {{ 'pages.organization.legalAddress' | translate }}
          </label>
        </div>
        <input
          class="form-control lna"
          id="legalAddress"
          [ngClass]="{
            invalid: this.shouldRenderError('legalAddress') && legalAddress?.errors
          }"
          type="text"
          formControlName="legalAddress"
          name="legalAddress" />
        <div class="error-wrapper">
          @if (this.shouldRenderError('legalAddress') && legalAddress?.errors) {
            @if (legalAddress?.errors?.['minlength']) {
              <small class="error-message">
                {{
                  'components.form.minLength'
                    | translate
                      : {
                          minLength: legalAddress?.errors?.['minlength']['requiredLength']
                        }
                }}
              </small>
            } @else if (legalAddress?.errors?.['maxlength']) {
              <small class="error-message">
                {{
                  'components.form.maxLength'
                    | translate
                      : {
                          maxLength: legalAddress?.errors?.['maxlength']['requiredLength']
                        }
                }}
              </small>
            }
          }
        </div>
      </div>
    </div>
  </div>
  </div>
</ng-template>

@if (isLoading && !isAddMode) {
  <app-spinner [isLoading]="isLoading" />
} @else if (isAddMode) {
  <ng-container [ngTemplateOutlet]="formFields" />
} @else if (isEditMode) {
  <form class="section">
    <div class="heading-wrapper">
      <h4>{{ 'pages.organization.general.title' | translate }}</h4>
      <div class="actions d-flex">
        <button class="primary" type="button" (click)="submit()">
          {{ 'pages.organization.saveChanges' | translate }}
        </button>
        <button class="secondary cancel" type="button" (click)="setIsEditMode(false, !hasFormChanged)">
          {{ 'pages.organization.cancel' | translate }}
        </button>
      </div>
    </div>
    <ng-container [ngTemplateOutlet]="formFields" />
  </form>
} @else {
  <div class="section">
    <div class="heading-wrapper">
      <h4>{{ 'pages.organization.general.title' | translate }}</h4>
      <div class="actions">
        @if (!legalEntity?.isDeleted) {
          <button class="secondary editOrganization" (click)="setIsEditMode(true, true)">
            {{ 'pages.organization.editOrganization' | translate }}
          </button>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 mb-4 value-wrapper">
        <p class="form-label">
          {{ 'pages.organization.registrationCountry' | translate }}
        </p>
        <p class="form-value">{{ legalEntity?.country?.name || '-' }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 mb-4 value-wrapper">
        <p class="form-label">
          {{ 'pages.organization.registrationNumber' | translate }}
        </p>
        <p class="form-value">{{ legalEntity?.registrationNumber || '-' }}</p>
      </div>
      <div class="col-12 col-md-4 mb-4 value-wrapper">
        <p class="form-label">
          {{ 'pages.organization.name' | translate }}
        </p>
        <p class="form-value">{{ legalEntity?.name || '-' }}</p>
      </div>
      <div class="col-12 col-md-4 mb-4 value-wrapper">
        <p class="form-label">
          {{ 'pages.organization.legalEntityForm' | translate }}
        </p>
        <p class="form-value">{{ getLegalEntityFormLabel() }}</p>
      </div>
    </div>
    <div class="contact-section">
      <div class="contact-info-heading">
        <h4 class="m-0">{{ 'pages.organization.contactInfoTitle' | translate }}</h4>
      </div>
      <div class="row">
        <div class="col-12 col-md-4 mb-4 value-wrapper">
          <p class="form-label">
            {{ 'pages.organization.email' | translate }}
          </p>
          <p class="form-value">{{ legalEntity?.email || '-' }}</p>
        </div>
        <div class="col-12 col-md-4 mb-4 value-wrapper">
          <p class="form-label">
            {{ 'pages.organization.phone' | translate }}
          </p>
          <p class="form-value">{{ legalEntity?.phone || '-' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-8 mb-4 value-wrapper">
          <p class="form-label">
            {{ 'pages.organization.legalAddress' | translate }}
          </p>
          <p class="form-value">{{ legalEntity?.legalAddress || '-' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4 mb-4">
          <p class="form-label">
            {{ 'pages.organization.general.contactInfoUpdatedAt' | translate }}
          </p>
          <p class="form-value">
            {{ formatDatetime(legalEntity?.modifiedOn || legalEntity?.createdOn || '', true) }}
          </p>
        </div>
      </div>
    </div>
  </div>
}

@if (!isAddMode) {
  <app-confirm-modal
    title="unsavedChanges"
    bodyText="unsavedChangesBody"
    confirmText="confirm"
    denyText="cancelBack"
    [isOpen]="isConfirmModalOpen"
    (cancel)="isConfirmModalOpen = false"
    (confirm)="setIsEditMode(false, true)" />
}
